<template>
  <div class="categories__warp clear">
    <div class="banner" v-if="showBanner">
      <el-carousel height="412px" trigger="hover">
        <el-carousel-item v-for="(banner, index) in bannerList" :key="index">
          <img class="pointer" style="height: 100%; width: 100%" :src="banner.pic" @click="linkTo(banner)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div v-if="showCategory" class="categories__warp__select" ref="category">
      <div class="categories__warp__select__parent">
        <div
          class="category"
          v-for="(category, index) in allCategory"
          :key="category.displayCategoryCode"
          @mouseenter="mouseenterCategory(index)"
          @mouseleave="mouseleaveCategory"
          @click="
            $emit('go-search', {
              title: '分类',
              content: category.displayCategoryName,
              code: category.displayCategoryCode
            })
          "
        >
          <span class="category__item">{{ category.displayCategoryName }}</span>
          <i v-if="category.children.length" class="el-icon-arrow-right" style="color: #bcbcbc"></i>
        </div>
      </div>

      <div
        v-show="showSecondar"
        class="secondar"
        :style="positionStyle"
        @mouseenter="showSecondar = true"
        @mouseleave="showSecondar = false"
      >
        <div class="container" v-for="category in childCategory" :key="category.displayCategoryCode">
          <div
            class="secondar__header vertical-align"
            @click="
              $emit('go-search', {
                title: '分类',
                content: category.displayCategoryName,
                code: category.displayCategoryCode
              })
            "
          >
            <span class="secondar__header__title overflow">{{ category.displayCategoryName }}</span>
            <i class="el-icon-arrow-right middle" style="color: #bcbcbc"></i>
          </div>
          <div class="secondar__list">
            <span
              v-for="child in category.children"
              :key="child.displayCategoryCode"
              class="secondar__list__item"
              @click="
                $emit('go-search', {
                  title: '分类',
                  content: child.displayCategoryName,
                  code: child.displayCategoryCode
                })
              "
            >
              {{ child.displayCategoryName }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showCategory: {
      type: Boolean,
      default: false
    },
    showBanner: {
      type: Boolean,
      default: false
    },
    allCategory: {
      ype: Array,
      default: () => []
    },
    bannerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showSecondar: false,
      positionStyle: {},
      childCategory: []
    };
  },
  methods: {
    mouseenterCategory(index) {
      if (!this.allCategory[index].children.length) return;
      this.childCategory = this.allCategory[index].children;
      this.positionStyle = { left: `${this.$refs.category.clientWidth}px` };
      this.showSecondar = true;
    },
    mouseleaveCategory({ relatedTarget }) {
      // 兼容移入滚动条触发mouseleave
      if (relatedTarget?._prevClass == 'categories__warp__select__parent') return;
      this.showSecondar = false;
    },
    linkTo({ ref }) {
      if (ref) window.open(ref);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/mixin.scss';
.categories__warp {
  &__select {
    position: relative;
    width: 192px;
    padding: 10px 0;
    border: 1px solid #d9d9d9;
    background: #ffffff;
    &__parent {
      overflow-y: scroll;
      height: 390px;
    }
    &__parent::-webkit-scrollbar {
      width: 4px;
      height: 12px;
    }
    &__parent::-webkit-scrollbar-thumb {
      border-radius: 2px;

      background: #dbdbdb;
    }
    .category {
      display: flex;
      height: 42px;
      color: #333333;
      padding: 0 16px;
      justify-content: space-between;
      align-items: center;
      &:hover {
        color: #1e8dff;
        background: #f5f5f5;
        cursor: pointer;
      }
      & + .category {
        margin-top: 8px;
      }
      &__item {
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
      }
    }
    .secondar {
      width: 1040px;
      min-height: 412px;
      padding: 0 12px;
      position: absolute;
      top: -1px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      z-index: 10;
      .container {
        display: flex;
      }
      &__header {
        display: flex;
        padding-top: 12px;
        width: 106px;
        min-width: 106px;
        height: 40px;
        line-height: 14px;
        color: #262626;
        text-align: center;
        &:hover {
          color: #1e8dff;
          cursor: pointer;
        }
        &__title {
          font-size: 12px;
          font-weight: 500;
        }
        .overflow {
          @include multiEllipsis;
        }
      }
      &__list {
        display: flex;
        flex-wrap: wrap;
        padding: 14px 0 6px 0;
        font-size: 12px;
        line-height: 1;
        &__item {
          margin-left: 24px;
          margin-bottom: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #595959;
          line-height: 1;
          &:hover {
            color: #1e8dff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .banner {
    float: right;
    width: 1040px;
  }
}
</style>
